/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class EmployeeRolesFormDirectiveController {

        public static $inject : string[] = [
            '$dealerwareNotification',
            '$dealerwareLoading',
            'DealerwareRoleModel',
            'CurrentUser'
        ];

        public employee: any;
        public roles: any;

        constructor(public $dealerwareNotification: any,
                    public $dealerwareLoading: any,
                    public DealerwareRoleModel: any,
                    public CurrentUser: any
        ) {}

        public roleSelectionDisabled(role: any) : boolean {
            return role.data.requires_role ? !this.getRole('admin').data.selected : false;
        }

        public updateRole(role: any) : void {
            var _self = this,
                _role = new this.DealerwareRoleModel(role.data),
                successCallback = function() {
                    loader.close();

                    // If current user roles were changed
                    if (_self.CurrentUser.user.data.id == _self.employee.employeeId) {
                        // Trigger UI changes linked to updated roles, e.g. side nav items.
                        _self.CurrentUser.loadCurrentUser({ forceReload: true });
                    }
                },
                errorCallback = function(response: any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                    role.data.selected = false;
                };

            var loader = this.$dealerwareLoading.show('Saving...');
            if (role.data.selected) {
                _role.$post({
                    promise: true,
                    params: {
                        location_id: this.employee.locationId,
                        employee_id: this.employee.employeeId
                    }
                }).then(successCallback, errorCallback);
            } else {
                if (role === this.getRole('admin')) { this.disableAdminDependentRoles(); }

                _role.$delete({
                    promise: true,
                    params: {
                        location_id: this.employee.locationId,
                        employee_id: this.employee.employeeId
                    }
                }).then(successCallback, errorCallback);
            }
        }

        private getRole(name: string) : any {
            return $.grep(this.roles.data, (r: any) => { return r.data.name === name; })[0];
        }

        private disableAdminDependentRoles() : void {
            var viewPositionRole = this.getRole('view_vehicle_position_during_contracts');

            if (viewPositionRole && viewPositionRole.data.selected) {
                viewPositionRole.data.selected = false;
                this.updateRole(viewPositionRole);
            }
        }
    }

    getDealerwareWebComponentsModule().controller('EmployeeRolesFormDirectiveController', EmployeeRolesFormDirectiveController);


    export class EmployeeRolesFormDirective implements ng.IDirective {

        public restrict         : string    =   'EA';
        public controller       : any       =   'EmployeeRolesFormDirectiveController';
        public controllerAs     : string    =   'rolesFormController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            employee: '=',
            roles: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/employee/roles/roles_form_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareEmployeeRolesForm",() => new EmployeeRolesFormDirective());

}
